/*
 * @Author: wanglongx
 * @Date: 2019-05-10 10:39:14
 * @LastEditors: Please set LastEditors
 * @desc 外层方案修改
 * @LastEditTime: 2024-08-26 10:54:28
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Dropdown, Input, HotKeys as NCHotKeys, Tooltip as NCTooltip, MultiLangText as NCMultiLangText } from '@platform/base';
// query items 
import { toast, getGlobalStorage } from '@platform/api';
import TipsTitle from './TipsTitle';
export default class Item extends Component {

    style = {};
    state = { isHover: false }
    //目前的高度最多能看到11个方案，多了之后会出现滚动条

    render() {

        const { chooseSearchPlan, item, searchAdvBtnClick, delSearchPlan, multiLang, searchInfo, value, setDefaultScheme, meta, runMode, renameSearchPlan } = this.props;
        const current = searchInfo.currentPlan || searchInfo.defaultPlan;
        let currentPlan = current.name;
        const currentpk = current.pk_ncc_queryscheme;
        let defaultDisPlay = meta.defaultDisPlay;
        if (defaultDisPlay === '00000000000000000000') {
            defaultDisPlay = '001';
        }
        searchInfo.defaultScheme = searchInfo.searchPlanCache.filter(i => i.pk_ncc_queryscheme === (defaultDisPlay));
        let iconClass = item.pk_ncc_queryscheme === (defaultDisPlay) ? ' icon-def' : '';
        let itemClass = currentPlan === value ? ' item-current' : '';
        let editClass = "";

        return (
            <div className={'query_item' + itemClass + editClass + ' '} ref={dom => {
                this.searchPlanDom = ReactDOM.findDOMNode(dom);
                if (this.searchPlanDom) {
                    this.searchPlanIcon = this.searchPlanDom.querySelector('.search-plan-set');
                    this.defaultIcon = this.searchPlanDom.querySelector('.icon-default-hover');
                    this.currentPlanIcon = this.searchPlanDom.querySelector('.icon-current-plan');
                }
            }}
            onMouseEnter={e => {
                // e.stopPropagation();
                if (this.searchPlanIcon) {
                    this.searchPlanIcon.style.display = "flex";
                }
                if (this.searchPlanDom) {
                    this.searchPlanDom.classList.add('item-current');
                }
                if (this.defaultIcon) {
                    this.defaultIcon.style.display = "none";
                }
            }}
            onMouseLeave={e => {
                // e.stopPropagation();
                if (this.searchPlanIcon) {
                    this.searchPlanIcon.style.display = "none";
                }
                if (!itemClass && this.searchPlanDom) {
                    this.searchPlanDom.classList.remove('item-current');
                }
                if (this.defaultIcon) {
                    this.defaultIcon.style.display = "inline";
                }
            }}
            >
                {

                    <div className="search_planName_flag" onClick={chooseSearchPlan}>
                        <TipsTitle title={value} className='search_planName'></TipsTitle>
                        {currentPlan == value && currentpk == this.props.item.pk_ncc_queryscheme ? <i className="iconfont icon-current-plan icon-liucheng1" /> : null}
                    </div>
                     
                }
                {
                    runMode === 'preview' ? null : (
                        <>
                            {iconClass && <i className="iconfont icon-not-visible icon-default-hover icon-sheweimoren" />}
                            <span
                                className="search-plan-set"
                            >{
                                    !item.isshared && <NCTooltip
                                        delayShow={800}
                                        inverse
                                        delayHide={1}
                                        overlay={multiLang['page-search-0093']}
                                        placement="top"
                                    >
                                        <i
                                            className="iconfont icon-cxzhongmingming"
                                            onClick={searchAdvBtnClick}
                                        />
                                    </NCTooltip>
                                }
                                <NCTooltip
                                    delayShow={800}
                                    delayHide={1}
                                    inverse
                                    overlay={iconClass ? multiLang['page-search-0097'] : multiLang['page-search-0095']}
                                    placement="top"
                                >
                                    <i
                                        className={"iconfont icon-not-visible icon-second icon-sheweimoren" + iconClass}
                                        onClick={e => {
                                            e.stopPropagation();
                                            if (iconClass) {return;}
                                            setDefaultScheme(item.pk_ncc_queryscheme);
                                        }}
                                    />
                                </NCTooltip>
                                {item.isMyPlan && <div
                                    className='hover-icon'
                                    onMouseEnter={e => {
                                        let position = e.target?.getBoundingClientRect();
                                        if (position) {
                                            this.style.top = (Math.round(position.bottom)) + 'px';
                                            this.style.left = (Math.round(position.right) - 18) + 'px';
                                        }
                                        if (this.searchPlanDom) {
                                            this.searchPlanDom.classList.add('item-current');
                                        }
                                        if (this.searchPlanIcon) {
                                            this.searchPlanIcon.style.display = "flex";
                                        }
                                        this.setState({ isHover: true });
                                    }}
                                    onMouseLeave={e => {
                                        this.setState({ isHover: false });
                                    }}>
                                    <i className="iconfont icon-not-visible icon-gengduo" />
                                    {this.state.isHover && ReactDOM.createPortal(<ul className="menu_items second_level" style={this.style}>
                                        <li
                                            className='menulist icon-not-visible'
                                            onClick={e => {
                                                e.stopPropagation();
                                                renameSearchPlan();
                                                this.setState({ isHover: false });
                                               
                                            }}
                                        >
                                            {multiLang['page-search-0092']}
                                        </li>
                                        <li className='menulist icon-not-visible'
                                            onClick={e => {
                                                e.stopPropagation();//删除
                                                delSearchPlan();
                                            }}>{multiLang['page-search-icon-delete']}</li>
                                    </ul>, document.body)}
                                </div>}
                            </span>
                        </>

                    ) 
                }
            </ div >
        );
    }

}